<script>
  import { Router, Route, Link, router, navigateTo } from "yrv";
  import Profile from "./Profile.svelte";
  import { auth, googleProvider } from "../firebase";
  import { authState } from "rxfire/auth";
  import Modal from "svelte-simple-modal";
  import Smiley from "./Smiley.svelte";

  let user;

  const unsubscribe = authState(auth).subscribe((u) => (user = u));

  function login() {
    navigateTo("/#login");
  }
</script>

<nav class="px-10 border-b">
  <ul class="flex items-center">
    <!-- <li>
      <img src="ant-nopadding.svg" style=""  alt="ant"/>
      </li> -->
    <li>
      <ul class="flex items-center space-x-4">
        <li>
          <Smiley smile="95" stroke="#ffffff" fill="#000000" />
        </li>
        <!-- <li class="p-4" class:selected={$router.path == "#home"}>
          
          <a
            href="https://journeymaps.app"
            class="navlink"
            >JourneyMaps</a
          >
        </li> -->

        {#if user}
          <li class="p-4" class:selected={$router.path == "/" || $router.path.includes("#maps")}>
            <Link
              href="/"
              class="navlink"
              
              >Your Maps</Link
            >
          </li>
        {/if}
      </ul>
    </li>
    <li class="ml-auto" class:profileselected={$router.path == "#profile"}>
      <div class="profile">
        <slot name="profile" />
      </div>
    </li>
  </ul>
</nav>

<style>
  nav {
    @apply bg-black text-white font-bold;
  }



  li.selected{
    position: relative;
  }
  li.selected::after {
    content: "";
    @apply block w-full h-1 bg-mapblue absolute bottom-0 left-0;
  }

  .profileselected img{
     @apply border-2 bg-mapblue;
   } 
</style>
